var $root = $('#headerGlobalNav'); // 対象要素を取得

var pos = 300; // メニューを固定するスクロール位置

var fixedClass = '-fixed'; // メニュー固定時クラス

$(window).on('load scroll', function () {
  if ($(this).scrollTop() > pos) {
    $root.addClass(fixedClass);
  } else {
    $root.removeClass(fixedClass);
  }
});